import compareAsc from 'date-fns/compareAsc';
import compareDesc from 'date-fns/compareDesc';

export const stringCompare = (a: string | undefined, b: string | undefined) =>
  a && b ? a.localeCompare(b, undefined, {sensitivity: 'base'}) : !a ? 1 : !b ? -1 : 0;
export const numericCompareAsc = (a: number, b: number) => (a > b ? 1 : a < b ? -1 : 0);
export const numericCompareDesc = (a: number, b: number) => (a > b ? -1 : a < b ? 1 : 0);
export const dateCompareAsc = (a: number | Date, b: number | Date) => compareAsc(a, b);
export const dateCompareDesc = (a: number | Date, b: number | Date) => compareDesc(a, b);

export const byProp =
  <T, K extends keyof T>(key: K, comparer: any = stringCompare) =>
  (a: T, b: T) =>
    comparer(<any>a[key], <any>b[key]);
export const byPropDesc =
  <T, K extends keyof T>(key: K, comparer: any = stringCompare) =>
  (a: T, b: T) =>
    comparer(<any>b[key], <any>a[key]);

export const sort = (comparer: any) => (xs: []) => xs.sort(comparer);

export const bySortingArray =
  <T, K extends keyof T>(key: K, sortingArray: T[keyof T][]) =>
  (a: T, b: T) =>
    sortingArray.indexOf(a[key]) - sortingArray.indexOf(b[key]);
